import * as Yup from "yup";

const EventParticipantSchema = (isEdit = false) =>
  Yup.object().shape({
    event_id: Yup.number().label("Event").nullable(),
    team_id: Yup.number().label("Participant Team").nullable(),
    rank: Yup.string().label("Rank").nullable(),
  });

export default EventParticipantSchema;
